import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import {
  LandingPage,
  OnboardingPage,
  CallbackPage,
  Dashboard,
  AnalysisDetailPage,
  CompaniesPage,
  CompanyDetailsPage,
  NotificationsPage,
  SettingsPage,
  ProfilePage,
  SubscriptionPage,
  ManageSubscriptionPage,
  SyncSubscriptionPage,
  PrivacyPolicyPage,
  TermsOfUsePage,
} from './pages';
import MainLayout from './layouts/MainLayout';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Rotas Públicas */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/politica-de-privacidade" element={<PrivacyPolicyPage />} />
          <Route path="/termos-de-uso" element={<TermsOfUsePage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/callback" element={<CallbackPage />} />
          <Route path="/assinatura/sincronizar" element={<SyncSubscriptionPage />} />

          {/* Rotas Protegidas com Layout Principal */}
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/analise/:analysisId" element={<AnalysisDetailPage />} />
            <Route path="/empresas" element={<CompaniesPage />} />
            <Route path="/empresas/:ticker" element={<CompanyDetailsPage />} />
            <Route path="/notificacoes" element={<NotificationsPage />} />
            <Route path="/configuracoes" element={<SettingsPage />} />
            <Route path="/perfil" element={<ProfilePage />} />
            <Route path="/assinatura" element={<SubscriptionPage />} />
            <Route path="/assinatura/gerenciar" element={<ManageSubscriptionPage />} />
          </Route>
          
          {/* Redirecionamento para rotas não encontradas */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;


